<template>
  <llp-page
    id="datatble-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
        <div class="card m-2 m-lg-3">
        <div class="card-body">
    
            <div class="row mb-md-4 align-items-center form-header">
            <div class="col mt-4 d-none d-sm-block" >
              <h4 class="ms-lg-4 ms-md-2">View Vendor User Details</h4>
            </div>
            <div class="col mt-4 d-block  d-sm-none">
                <h5>View Vendor User</h5>
            </div>
            <div class="col-12 col-sm-6 col-md-4 d-flex justify-content-end ">
              <llp-button
                classNames="btn-secondary new-btn d-none d-sm-block"
                @click="BackToServices()"
              >
                 Back To Vendor Payments
              </llp-button>
               <llp-button
                classNames="btn-secondary new-btn d-block d-sm-none add-btn"
                @click="BackToServices()"
              >
                Go Back
              </llp-button>
            </div>
          </div>
        
            <div class="col-lg-8 col-md-12 col-sm-12 m-lg-4 m-md-2">
             
              <div class="card p-4">
                <div class="row">
                     <div class="col-lg-6 col-md-6 col-sm-12 mt-3">
                  <llp-label id="nameLabel">Name:</llp-label>
                  <llp-input
                    id="vendorId"
                    class="w-100"
                    autocomplete="off"
                    v-model="vendor"
                    disabled
                  ></llp-input>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 mt-3">
                  <llp-label id="addressLabel">Address:</llp-label>
                  <llp-input
                    id="addressId"
                    class="w-100"
                    autocomplete="off"
                    v-model="address"
                    disabled
                  ></llp-input>
                </div>
                
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 mt-3">
                  <llp-label id="panNumberLabel">Pan Number:</llp-label>
                  <llp-input
                    id="panNumberId"
                    class="w-100"
                    autocomplete="off"
                    v-model="panNumber"
                    disabled
                  ></llp-input>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 mt-3">
                  <llp-label id="mobileLabel">Mobile:</llp-label>
                  <llp-input
                    id="mobileId"
                    class="w-100"
                    autocomplete="off"
                    v-model="mobile"
                    disabled
                  ></llp-input>
                </div>
                </div>
               <div class="row">
                 <div class="col-lg-6 col-md-6 col-sm-12 mt-3">
                  <llp-label id="amountLabel">Amount:</llp-label>
                  <llp-input
                    id="amountId"
                    class="w-100"
                    autocomplete="off"
                    v-model="amount"
                    disabled
                  ></llp-input>
                </div>
               </div>
                   <h5 class="mt-2 fw-bold bank-details">Bank Info</h5>
                  <div class="col-lg-12 col-md-12 col-sm-12 mt-4">
                    <div class="card mb-4">
                      <div class="card-body">
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                    <llp-label id="accountNumber" :aria-label="AccountNumber"
                      >Account Number:</llp-label
                    >
                    <llp-input
                      id="MonthlyRentInput"
                      v-model="accountNumber"
                      class="w-100"
                      autocomplete="off"
                      disabled
                    ></llp-input>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                    <llp-label id="pincodeLabel" :aria-label="name"
                      >Account Holder Name:</llp-label
                    >
                    <llp-input
                      id="accountName"
                      class="w-100"
                      autocomplete="off"
                      v-model="accountHolderName"
                      disabled
                      
                    ></llp-input>
                  </div>
                </div>
                <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label>Bank Name:</llp-label>
                      <llp-input
                        class="w-100"
                        v-model="bankName"
                        disabled
                      />
                    </div>
                 
                 <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label>IFSC Code:</llp-label>
                      <llp-input
                        class="w-100"
                        v-model="ifscCode"
                        disabled
                      />
                    </div>
                </div>
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                      <llp-label>Branch:</llp-label>
                      <llp-input
                        class="w-100"
                        v-model="branch"
                        disabled
                      />
                    </div>
                </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>

        </div>
      </div>
      </div>
      
    </template>
  </llp-page>
   <llp-toast ref="toast"></llp-toast>
</template>

<script>

import NetworkService from '@/services/network.service';

export default {
  
  data()
  {
    return {
      vendor:'',
      panNumber:'',
      mobile:'',
      amount:'',
      address:'',
       accountNumber: "",
      bankName: "",
      accountHolderName: "",
      ifscCode: "",
      branch:"",
      userDetails:[],
        serviceId: this.$route.params.serviceId,
      itemId:this.$route.params.id,
      userId: localStorage.getItem("User_id"),
    }
  },
   
  mounted()
  {
      this.fetchingVendorDetails();
  },

  methods: {
    BackToServices() {
     this.$router.back();
    },
    async fetchingVendorDetails()
    {
       try {
        const rentalResponse = await  NetworkService.get(`/get-service-list-view/${this.itemId}/${this.userId}/${this.serviceId}`);
         this.userDetails = rentalResponse.details
      this.vendor=this.userDetails.name;
      this.address = this.userDetails.address;
       const pan = this.userDetails.pan_number;
    this.panNumber = pan ? "*".repeat(pan.length - 4) + pan.slice(-4) : "";
      this.mobile = this.userDetails.mobile;
      this.amount = this.userDetails.amount;
      this.accountHolderName = this.userDetails.account_holder_name;
        this.accountNumber=this.userDetails.account_number;
        this.bankName=this.userDetails.bank_name;
        this.ifscCode = this.userDetails.ifsc_code;
        this.branch = this.userDetails.bank_branch
      } catch (error) {
        if(error.message){
            this.$refs.toast.show(error.message,"error")
        }else{
           this.$refs.toast.show(
              "Unable to fetching the vendor details",
              "error"
            );
        }
      }
    }
  },
};
</script>

